<!-- eslint-disable -->
<template>
  <div class="dashboard-container">
    <se-breadcrumb :itemData="breadData" showBottomBorder class="dashboard-breadcrumb"></se-breadcrumb>
    
    <div class="dashboard-header">
      <div class="header-title">
        <h2>{{ activityName || '组合营销数据' }}</h2>
      </div>
    </div>
    
    <div class="data-panel">
      <!-- 表格数据搜索和标签页 -->
      <div class="data-panel-header">
        <el-tabs v-model="tabName" @tab-click="(e)=>tabChange(e, $refs.list ? $refs.list.getParams() : {}, 1)" class="dashboard-tabs">
          <el-tab-pane label="兑换 | 购买订单" name="1"></el-tab-pane>
        </el-tabs>
        
        <div class="search-section">
          <el-row :gutter="20">
            <el-col :span="6" v-if="tabName==1||tabName==3">
              <el-input 
                placeholder="请输入手机号" 
                v-model="searchData.customerMobile" 
                prefix-icon="el-icon-mobile-phone"
                class="search-input">
              </el-input>
            </el-col>
            <el-col :span="8" v-if="tabName==2||tabName==3">
              <el-date-picker
                class="date-picker"
                v-model="activeDateTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="pickerDateChange"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-col>
            <el-col :span="4" class="search-buttons">
              <el-button @click="resetSearchData" icon="el-icon-refresh" class="reset-btn">重置</el-button>
              <el-button ref="searchButton" @click="pageHandler($refs.list ? $refs.list.getParams() : {}, 1)" type="primary" icon="el-icon-search" class="search-btn">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      
      <!-- 列表展示 -->
      <div class="table-wrapper">
        <my-table 
          ref="list" 
          :data="tableList" 
          @page="pageHandler" 
          :listLoading="listLoading" 
          class="data-table"
          empty-text="暂无数据">
          
          <!-- 自定义表头区域 -->
          <template #header>
            <div class="custom-header">
              <div class="table-title">
                <span class="title-text">数据列表</span>
                <span class="count-tag" v-if="tableList && tableList.length">共 {{ tableList.length }} 条</span>
              </div>
            </div>
          </template>
          
          <!-- 自定义列渲染 -->
          <template v-for="(item, idx) in tableData">
            <el-table-column 
              v-if="item.prop === 'customerMobile'" 
              :key="'col-mobile-' + idx"
              :label="item.label" 
              :prop="item.prop" 
              :min-width="item.width"
              align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="handleUserView(scope.row)" class="mobile-link">
                  {{ scope.row.customerMobile }}
                </el-button>
              </template>
            </el-table-column>
            
            <el-table-column 
              v-else-if="item.prop === 'paymentPrice'" 
              :key="'col-price-' + idx"
              :label="item.label" 
              :prop="item.prop" 
              :min-width="item.width"
              align="center">
              <template slot-scope="scope">
                <span class="price-text">{{ scope.row.paymentPrice }}</span>
              </template>
            </el-table-column>
            
            <el-table-column 
              v-else-if="item.prop === 'stateName'" 
              :key="'col-state-' + idx"
              :label="item.label" 
              :prop="item.prop" 
              :min-width="item.width"
              align="center">
              <template slot-scope="scope">
                <el-tag 
                  :type="scope.row.stateName === '已支付' ? 'success' : 'info'" 
                  size="small">
                  {{ scope.row.stateName }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column 
              v-else 
              :key="'col-other-' + idx"
              :label="item.label" 
              :prop="item.prop" 
              :min-width="item.width"
              align="center">
            </el-table-column>
          </template>
        </my-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import t from "@common/src/i18n/t";
import {namespace} from "vuex-class";
const marketing = namespace("marketing");
import { emptyToLine, splitThousands } from "@/utils/common";


export default {
  components: {},
    data() {
      return {
        packageCode: '',
        activityName: '',                                   //活动名称
        tabName: '1',                                       //列表标签页
        searchData: {                                       //查询数据
          customerMobile: '',
          dateStart: '',
          dateEnd: ''
        },
        tableList: [{}],                                      //列表数据
        listLoading: false,                                 //列表loading
        activityDetailData: [                               //活动参与明细展示字段
          { label: "订单号", width: 160, prop: "orderNo" },
          { label: "手机号", width: 100, prop: "mobile" },
          { label: "用户姓名", width: 100, prop: "userName" },
          { label: "支付方式", width: 150, prop: "paidMethodName" },
          { label: "支付状态", width: 150, prop: "stateName" },
          { label: "金额", width: 100, prop: "paymentPrice" },
          { label: "数量", width: 180, prop: "quantity" },
          { label: "购买时间", width: 150, prop: "ctime" },
        ],
        activeDateTime: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      };
    },
  computed: {
    breadData() {
      return [
        { name: "组合营销", path: "/combinedPackage/list" },
        {
          name: "数据面板"
        }
      ];
    }
  },
  watch: {},
  methods: {
    pageHandler(params, num) {
      switch (this.tabName) {
        case '1':
          //兑换购买人数
          this.getPromoPackageUser(params, num ? num : params.pageNum, params.pageSize);
          break;
        case '2':
          break;
        default:
          break;
      }
    },
    // 重置搜索数据
    resetSearchData() {
      this.searchData = {                                       //查询数据
        customerMobile: '',
        dateStart: '',
        dateEnd: ''
      }
      this.activeDateTime = [];
    },
    // 标签点击
    tabChange(e, params, num){
      this.searchData = {                                       //查询数据
        customerMobile: '',
        dateStart: '',
        dateEnd: ''
      }
      this.activeDateTime = [];
      switch (e.name) {
        case '1':  //兑换购买人数
          this.getPromoPackageUser(params, num ? num : params.pageNum, params.pageSize).then(()=>{
            this.tabName = e.name;
          });
          break;
        case '2':
          break;
        case '3':
          break;
        default:
          break;
      }
    },
    // 时间范围选择
    pickerDateChange(e){
      this.searchData.dateStart = e[0];
      this.searchData.dateEnd = e[1];
    },

    // 获取用户购买人数
    async getPromoPackageUser(params,pageNum,pageSize){
      await this.$store.dispatch('management/getPromoPackageUser',{
        packageCode: this.packageCode,
        pageNum,
        pageSize
      }).then(res => {
        this.tableData = this.activityDetailData;
        this.tableList = res.data.list;
        params.render(res.data.total);
      })
    },
    handleUserView(row) {
      let { href } = this.$router.resolve({
        path: `/customer/customer-view/${row.customerMobile}`
      });
      window.open(href, "_blank");
    }
  },
  created() {
    this.packageCode = this.$route.params.id;
    this.activityName = this.$route.query.activityName;
    this.tabName = '1';
    this.tableData = this.activityDetailData;
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.dashboard-container {
  padding: 0 20px 20px;
  box-sizing: border-box;
  
  .dashboard-breadcrumb {
    margin-bottom: 16px;
  }
  
  .dashboard-header {
    background-color: #fff;
    border-radius: 4px;
    padding: 16px 20px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    
    .header-title {
      h2 {
        font-size: 18px;
        font-weight: 600;
        margin: 0;
        color: #303133;
      }
    }
  }
  
  .data-panel {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    overflow: hidden;
    
    .data-panel-header {
      padding: 16px 20px 0;
      
      .dashboard-tabs {
        margin-bottom: 16px;
        
        ::v-deep .el-tabs__nav-wrap {
          padding-left: 0 !important;
        }
        
        ::v-deep .el-tabs__item {
          height: 40px;
          line-height: 40px;
          font-size: 15px;
        }
        
        ::v-deep .el-tabs__active-bar {
          height: 3px;
        }
      }
      
      .search-section {
        padding-bottom: 16px;
        border-bottom: 1px solid #EBEEF5;
        
        .search-input, .date-picker {
          width: 100%;
        }
        
        .search-buttons {
          display: flex;
          justify-content: flex-start;
          
          .reset-btn {
            margin-right: 10px;
          }
          
          .search-btn {
            &:hover {
              opacity: 0.9;
            }
          }
        }
      }
    }
    
    .table-wrapper {
      padding: 0 16px 16px;
      
      .custom-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        
        .table-title {
          display: flex;
          align-items: center;
          
          .title-text {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
          }
          
          .count-tag {
            margin-left: 12px;
            font-size: 13px;
            color: #909399;
            background-color: #f0f2f5;
            padding: 2px 8px;
            border-radius: 12px;
          }
        }
      }
      
      .data-table {
        ::v-deep .el-table {
          border-radius: 4px;
          overflow: hidden;
          
          th {
            background-color: #f5f7fa;
            color: #606266;
            font-weight: 500;
          }
          
          tbody tr:hover > td {
            background-color: #f5f7fa;
          }
          
          .mobile-link {
            color: #409EFF;
            font-weight: 500;
            
            &:hover {
              text-decoration: underline;
            }
          }
          
          .price-text {
            color: #F56C6C;
            font-weight: 500;
          }
        }
      }
    }
  }
  
  .title {
    margin: 24px 0 20px 0;
    h2 {
      .look-coupon {
        color: $link-color;
        font-size: 14px;
        font-weight: 200;
        margin-left: 16px;
      }
    }
  }
  
  .analysis_box{
    min-width: 1300px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .analysis_item{
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
      .analysis_item_title{
        padding: 0px 15px;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        font-size: 16px;
        border-bottom: 1px solid #dfe4ed;
      }
    }
    .analysis_item_left{
      width: 902px;
      height: 330px;
      margin-right: 10px;
      .analysis_chart_box{
        width: 802px;
        height: 244px;
        margin: 20px auto;
        background: url(../../../assets/img/campain-analysis-bg.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        .num_box{
          height: 100%;
          position: absolute;
          left: 290px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          .num_item{
            display: flex;
            align-items: center;
            text-align: center;
            .num_share>:last-child{
              color: #8c8c8c;
            }
          }
          .num_item>div{
            width: 100px;
          }
          .num_item >div:first-child{
            margin-right: 165px;
            color: #fff;
            font-weight: bold;
            font-size: 16px;
          }
        }
        .probability_box{
          position: absolute;
          text-align: center;
          >div:last-child{
            font-size: 15px;
            font-weight: bold;
          }
          >div:first-child{
            color: #8c8c8c;
          }
        }
        .probability_1{
          left: 90px;
          top: 55px;
        }
        .probability_2{
          left: 90px;
          bottom: 65px;
        }
        .probability_3{
          top: 95px;
          left: -30px;
        }
      }
    }
    .analysis_item_right{
      flex: 1;
      height: 330px;
      .analysis_item_right1{
        height: 120px;
        margin-bottom: 10px;
        .analysis_item_right1_content{
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: bold;
          color: #333;
        }
      }
      .analysis_item_right2{
        height: 200px;
        .analysis_item_right2_content{
          height: 160px;
          margin-top: 30px;
          color: #333;
          .item{
            text-align: center;
            font-size: 15px;
            font-weight: bold;
          }
          .down{
            margin-top: 20px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .item{
              font-size: 13px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
